export default [
  {
    name: 'contractAction_toContractInput',
    path: '/contract/contractAction_toContractInput.action',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      title: '起草合同'
    }
  },
  {
    name: 'fapiaoApplication_toFapiaoApplicationAdding',
    path: '/fapiao/fapiaoApplication_toFapiaoApplicationAdding.action',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      title: '填写开票申请'
    }
  },
  {
    name: 'costAction_toAddApplication',
    path: '/cost/costAction_toAddApplication.action',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      title: '填写出差申请'
    }
  },
  {
    name: 'borrowInputAction_toBorrowInput',
    path: '/borrow/borrowInputAction_toBorrowInput.action',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      title: '填写借款申请'
    }
  },
  {
    name: 'sealApplicationAction_toSealApplicationAdding',
    path: '/seal/sealApplicationAction_toSealApplicationAdding.action',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      title: '填写印鉴申请'
    }
  },
];
